/*! @pentacode/ui v0.1.0 */
import "../../../checkbox-B7K20jTx.js";
import { FormElement as e } from "../../formElement.js";
import { t } from "../../../styledElement-DUAqv8gi.js";
import { t as n } from "../../../decorateMetadata-BXz2gmG4.js";
import { t as r } from "../../../decorate-C_HUHFGG.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s, state as c } from "lit/decorators.js";
// src/elements/employee-questionnaire/shared/working-student-facts-section.ts
var l = class extends t(e(i)) {
	constructor(...e) {
		super(...e), this.data = {
			lowSalary: !1,
			shortTermEmployment: !1,
			moreThan20hOutsideSemesterBreak: !1,
			vacationSemester: !1,
			semesterAbove25: !1,
			moreThan182DaysOver20h: !1
		}, this._lowSalary = !1, this._shortTermEmployment = !1, this._moreThan20hOutsideSemesterBreak = !1, this._vacationSemester = !1, this._semesterAbove25 = !1, this._moreThan182DaysOver20h = !1;
	}
	willUpdate(e) {
		e.has("data") && this.data && (this._lowSalary = this.data.lowSalary, this._shortTermEmployment = this.data.shortTermEmployment, this._moreThan20hOutsideSemesterBreak = this.data.moreThan20hOutsideSemesterBreak, this._vacationSemester = this.data.vacationSemester, this._semesterAbove25 = this.data.semesterAbove25, this._moreThan182DaysOver20h = this.data.moreThan182DaysOver20h);
	}
	_handleSectionChange() {
		this.dispatchEvent(new CustomEvent("change", {
			detail: {
				lowSalary: this._lowSalary,
				shortTermEmployment: this._shortTermEmployment,
				moreThan20hOutsideSemesterBreak: this._moreThan20hOutsideSemesterBreak,
				vacationSemester: this._vacationSemester,
				semesterAbove25: this._semesterAbove25,
				moreThan182DaysOver20h: this._moreThan182DaysOver20h
			},
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return a`
            <section class="w-full">
                <h2 class="mb-2 px-2 text-xl font-semibold">Sachverhalte</h2>
                <p class="mb-4 px-2 text-sm text-gray-600">
                    Bitte kreuzen Sie alle Sachverhalte an, die für Sie zutreffen:
                </p>

                <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="lowSalary"
                            name="lowSalary"
                            .checked=${this._lowSalary}
                            @change=${(e) => {
			e.stopPropagation(), this._lowSalary = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="lowSalary" class="text-sm font-medium text-gray-700">
                            Gehalt
                            <span class="block text-xs text-gray-500"
                                >Sie werden unter 556€ brutto im Monat verdienen</span
                            >
                        </label>
                    </div>

                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="shortTermEmployment"
                            name="shortTermEmployment"
                            .checked=${this._shortTermEmployment}
                            @change=${(e) => {
			e.stopPropagation(), this._shortTermEmployment = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="shortTermEmployment" class="text-sm font-medium text-gray-700">
                            Kurzfristige Beschäftigung
                            <span class="block text-xs text-gray-500"
                                >Die Beschäftigung ist von vorne herein auf 70 Arbeitseinsätze befristet.</span
                            >
                        </label>
                    </div>

                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="moreThan20hOutsideSemesterBreak"
                            name="moreThan20hOutsideSemesterBreak"
                            .checked=${this._moreThan20hOutsideSemesterBreak}
                            @change=${(e) => {
			e.stopPropagation(), this._moreThan20hOutsideSemesterBreak = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="moreThan20hOutsideSemesterBreak" class="text-sm font-medium text-gray-700">
                            Über 20h außerhalb der Semesterferien
                            <span class="block text-xs text-gray-500"
                                >Die wöchentliche Arbeitszeit beträgt außerhalb der Semesterferien mehr als 20
                                Stunden.</span
                            >
                        </label>
                    </div>

                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="vacationSemester"
                            name="vacationSemester"
                            .checked=${this._vacationSemester}
                            @change=${(e) => {
			e.stopPropagation(), this._vacationSemester = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="vacationSemester" class="text-sm font-medium text-gray-700">
                            Urlaubssemester
                            <span class="block text-xs text-gray-500">Sie sind im Urlaubssemester.</span>
                        </label>
                    </div>

                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="semesterAbove25"
                            name="semesterAbove25"
                            .checked=${this._semesterAbove25}
                            @change=${(e) => {
			e.stopPropagation(), this._semesterAbove25 = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="semesterAbove25" class="text-sm font-medium text-gray-700">
                            26. Fachsemester oder höher
                            <span class="block text-xs text-gray-500">Sie sind im 26. Fachsemester oder höher.</span>
                        </label>
                    </div>

                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="moreThan182DaysOver20h"
                            name="moreThan182DaysOver20h"
                            .checked=${this._moreThan182DaysOver20h}
                            @change=${(e) => {
			e.stopPropagation(), this._moreThan182DaysOver20h = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="moreThan182DaysOver20h" class="text-sm font-medium text-gray-700">
                            Mehr als 182 Tage mit >20h/Woche gearbeitet
                            <span class="block text-xs text-gray-500"
                                >Sie haben im letzten Jahr an mehr als 182 Kalendertagen eine Beschäftigung mit einer
                                wöchentlichen Arbeitszeit von mehr als 20 Stunden ausgeübt.</span
                            >
                        </label>
                    </div>
                </div>
            </section>
        `;
	}
};
r([s({ type: Object }), n("design:type", Object)], l.prototype, "data", void 0), r([c(), n("design:type", Object)], l.prototype, "_lowSalary", void 0), r([c(), n("design:type", Object)], l.prototype, "_shortTermEmployment", void 0), r([c(), n("design:type", Object)], l.prototype, "_moreThan20hOutsideSemesterBreak", void 0), r([c(), n("design:type", Object)], l.prototype, "_vacationSemester", void 0), r([c(), n("design:type", Object)], l.prototype, "_semesterAbove25", void 0), r([c(), n("design:type", Object)], l.prototype, "_moreThan182DaysOver20h", void 0), l = r([o("ptc-ui-employee-questionnaire-working-student-facts-section")], l);
export { l as EmployeeQuestionnaireWorkingStudentFactsSection };

//# sourceMappingURL=working-student-facts-section.js.map